export const GLOBAL_STATE = 'RecruitmentInquiry'

export const RECRUITMENT_INQUIRY = 'RECRUITMENT_INQUIRY'
export const RECRUITMENT_INQUIRY_CREATE = 'RECRUITMENT_INQUIRY_CREATE'
export const RECRUITMENT_INQUIRY_DELETE = 'RECRUITMENT_INQUIRY_DELETE'
export const RECRUITMENT_INQUIRY_LIST = 'RECRUITMENT_INQUIRY_LIST'
export const RECRUITMENT_INQUIRY_UPDATE_STATUS = 'RECRUITMENT_INQUIRY_UPDATE_STATUS'
